import { Landmark, ShieldCheck, Medal } from "lucide-react";
import { Reveal, ChapterLabel } from "./Reveal";

const CARDS = [
  {
    icon: Landmark,
    title: "Well-Capitalized Growth Platform",
    items: [
      "Strong capital position and resources to accelerate growth",
      "Established DoD relationships and contract vehicle infrastructure",
      "Built for speed — fast, decisive time-to-contract",
    ],
  },
  {
    icon: ShieldCheck,
    title: "Full Compliance Stack, Ready to Scale",
    items: [
      "AS9100 Rev D, ISO 9001:2015, ITAR registration, CMMC 2.0, NADCAP",
      "Compliance engineered into every process, workflow & employee role",
      "Hardened, NIST SP 800-171 aligned IT architecture for CUI",
    ],
  },
  {
    icon: Medal,
    title: "Veteran-Led Culture",
    items: [
      "Founded by decorated, service-disabled U.S. Navy veteran & CEO Travis Mack",
      "Mission-first values and hands-on craftsmanship at every level",
    ],
  },
];

export const WhyPartner = () => (
  <section data-testid="why-partner-section" className="bg-white py-24 sm:py-32 px-6 sm:px-10">
    <div className="max-w-7xl mx-auto">
      <Reveal>
        <ChapterLabel number="02" title="Why Partner With DPM" />
        <h2 className="font-heading mt-8 text-3xl md:text-4xl font-bold tracking-tight text-[#0B1B3D] max-w-2xl">
          A credible acquirer, engineered for the defense industrial base.
        </h2>
      </Reveal>

      <div className="mt-16 grid md:grid-cols-3 gap-6">
        {CARDS.map((card, i) => (
          <Reveal key={card.title} delay={i * 0.12}>
            <div data-testid={`partner-card-${i}`} className="partner-card h-full p-8 sm:p-10 flex flex-col">
              <div className="flex items-start justify-between">
                <span className="pc-icon inline-flex items-center justify-center w-14 h-14 border border-[#0B1B3D]/20 text-[#0B1B3D]">
                  <card.icon size={26} strokeWidth={1.5} />
                </span>
                <span className="pc-index font-heading text-sm font-bold text-[#0B1B3D]/25">
                  0{i + 1}
                </span>
              </div>
              <h3 className="pc-title font-heading mt-8 text-xl font-bold tracking-tight text-[#0B1B3D]">
                {card.title}
              </h3>
              <ul className="mt-6 space-y-4 flex-1">
                {card.items.map((item) => (
                  <li key={item} className="pc-item flex gap-3 text-sm leading-relaxed text-[#4B5563]">
                    <span className="mt-[7px] w-3 h-px bg-[#C5A059] shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
